module.exports = __webpack_public_path__ + "img/adjust.7482ebb9.svg";